import React, { ReactNode, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import StyledSider from './styles'
import SiderMenu from './SiderMenu'
import Icon from '../../Icon'
import paths from '../../../routes/paths'
import LOGO from '../../../assets/logo/logo-ratio.png'
import SiderAccount from './SiderAccount'

export const siderItems: {
  icon: IconProp
  key: string
  label: string
  path: string
  disabled?: boolean
}[] = [
  {
    icon: 'chart-simple',
    key: 'dashboard',
    label: 'Dashboard',
    path: paths.home,
  },
  {
    icon: 'square-plus',
    key: 'new',
    label: 'New',
    path: paths.new,
  },
  {
    icon: 'industry',
    key: 'plants',
    label: 'Plants',
    path: paths.plants,
  },
  {
    icon: 'binoculars',
    key: 'scenarios',
    label: 'Scenarios',
    path: paths.scenarios,
  },
  {
    icon: 'memory',
    key: 'storageSystems',
    label: 'Storage Systems',
    path: paths.storageSystems,
  },
  {
    icon: 'square-poll-horizontal',
    key: 'results',
    label: 'Results',
    path: paths.results,
  },
  {
    icon: 'user',
    key: 'users',
    label: 'Users',
    path: paths.users,
    disabled: true,
  },
]

const renderItems = siderItems.map(({ icon, key, label, path, disabled }) => ({
  icon: <Icon icon={icon} color='inherit' margin={false} />,
  key,
  label,
  path,
  disabled,
}))

const Sider: React.FC<{ children: ReactNode }> = (props) => {
  const location = useLocation()
  const [selected, setSelected] = useState('')

  useEffect(() => {
    const curPath = location.pathname
    const selectedSiderItem = siderItems.find(({ path }) => path === curPath)

    if (selectedSiderItem) {
      setSelected(selectedSiderItem?.key)
    }
  }, [location.pathname])

  return (
    <StyledSider {...props}>
      <div>
        <Link to={paths.home}>
          <img className='sider-logo' src={LOGO} />
        </Link>

        <SiderMenu selectedKeys={[selected]} mode='vertical'>
          {renderItems.map(({ icon, label, path, disabled, key }) => (
            <SiderMenu.Item key={key} icon={icon} disabled={disabled}>
              <Link key={key} to={path}>
                {label}
              </Link>
            </SiderMenu.Item>
          ))}
        </SiderMenu>
      </div>

      <SiderAccount />
    </StyledSider>
  )
}

export default Sider
